module.exports = __webpack_public_path__ + "../resources/img/ic_ellipsis.c46b82eb.svg";